<template>
  <div>
    <v-flex md12 xs12 sm12>
      <v-card max-width="300px" width="100%" hover>
        <v-img :src="welcome.image" aspect-ratio="1.75" contain></v-img>
        <v-card-title primary-title>
          <div>
            <h5 class="subheading mb-0">{{welcome.name}} {{welcome.last_name}}</h5>
            <span class="grey--text">
              <v-icon medium small>cake</v-icon>
              {{welcome.birthday}}
            </span>
            <br>
            <span class="grey--text">Ingresó el {{welcome.created_at | moment("DD-MM-YYYY" )}}</span>
            <br>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn flat color="orange">Saludar</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    welcome: {
      type: Object,
      required: true
    }
  }
};
</script>
